import classNames from 'classnames';
import React from 'react';
import styles from './Separator.css';

interface SeparatorProps {
  orientation?: 'horizontal' | 'vertical';
  decorative?: boolean;
  className?: string;
}

const Separator: React.FC<SeparatorProps> = ({
  orientation = 'horizontal',
  decorative = false,
  className
}) => {
  return (
    <hr
      aria-orientation={orientation}
      aria-hidden={decorative || undefined}
      className={classNames(styles.separator, className)}
    />
  );
};

export default Separator;
